module.exports = __webpack_public_path__ + "static/media/preview.c828d93c.png";